const stringToNone = str => {
  if (typeof str !== 'string' || str === 'None') return null;
  return str;
};

export default stringToNone;
